import { Branches } from "@/@types/Branches";
import { BranchesResponse } from "../../branches/models/BranchesResponses";

export const mapBranches = (data: BranchesResponse): Branches => {

    return {
        state: data.state,
        stateSlug: data.state_slug,
        types: data.types.map(data => {
            return {
                typeBranch: data.type_branch,
                typeBranchSlug: data.type_branch_slug,
                branches: data.branches.map(branch => {
                    return {
                        order: branch.order,
                        name: branch.name,
                        slug: branch.slug
                    }
                })
            }
        })
    }
}
